<style lang="stylus">
    .rightclickmenu-aiorgchart
        .ft-menu
            cursor pointer
            .ft-menutext
                font-size 14px
        floatTool_dropbox()
</style>

<template>
    <div class="rightclickmenu-aiorgchart">
        <AIFloatMenuPictureAnalysis :fromType="'rightClickMenu'" />
        <div class="ft-aigray-text" :class="{ 'ft-h-divided': !internal }">
            <p>{{ $t("orgAI") }}</p>
        </div>
        <FtMenu
            v-for="item in aiMenu"
            :imgIcon="item.icon"
            :text="$t(item.label)"
            :key="item.label"
            :placement="'right'"
            @clickMenu="clickAiMenu(item.id, item.label)"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";
    import FtMenu from "@/app/components/FloatTool/public/FtMenu.vue";
    import { aiStatusType } from "@/app/components/ai3/enum";
    import AIFloatMenuPictureAnalysis from "@/app/components/FloatTool/AIFloatMenuPictureAnalysis.vue";

    @Component({
        components: {
            FtMenu,
            AIFloatMenuPictureAnalysis,
        },
    })
    export default class AiOrg extends Vue {
        aiMenu = [
            {
                id: aiStatusType.orgAnalyse,
                icon: "ai-org-analysis",
                label: "analysis",
            },
            {
                id: aiStatusType.orgDiagnosis,
                icon: "ai-org-diagnosis",
                label: "check",
            },
        ];

        clickAiMenu(id, label) {
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("aiAnalyse", id, this.$t(label));
                this.aiTrackData(id);
            });
            this.$store.commit("closeContext");
        }
        aiTrackData(id) {
            const obj = {
                [aiStatusType.orgAnalyse]: "Organization Analysis",
                [aiStatusType.orgDiagnosis]: "Organization Diagnosis",
            };
            this.sensors.track("clickOrgAI", {
                Catalogues: "orgAI",
                click_type: obj[id],
            });
        }
    }
</script>
<i18n>
{
    "zh": {
        "orgAI": "组织结构图分析",
        "analysis": "组织分析",
        "check": "组织诊断"
    },
    "en": {
        "orgAI": "Organizational Chart Analysis",
        "analysis": "Organization Analysis",
        "check": "Organization Diagnosis"
    },
    "de": {
        "orgAI": "Organigramm-Analyse",
        "analysis": "Organisationsanalyse",
        "check": "Organisationsdiagnose"
    },
    "es": {
        "orgAI": "Análisis de organigrama",
        "analysis": "Análisis de organización",
        "check": "Diagnóstico de organización"
    },
    "fr": {
        "orgAI": "Analyse d'organigramme hiérarchique",
        "analysis": "Analyse d'organisation",
        "check": "Diagnostic d'organisation"
    },
    "it": {
        "orgAI": "Analisi organigramma",
        "analysis": "Analisi organizzazione",
        "check": "Diagnosi organizzazione"
    },
    "jp": {
        "orgAI": "組織図分析",
        "analysis": "組織分析",
        "check": "組織診断"
    },
    "pt": {
        "orgAI": "Análise de organograma",
        "analysis": "Análise da organização",
        "check": "Diagnóstico da organização"
    },
    "tw": {
        "orgAI": "組織圖分析",
        "analysis": "組織分析",
        "check": "組織診斷"
    }
}
</i18n>
